<style lang="stylus">
    .scroller_container
        position absolute
        .scroller_outer_x
            position relative
            width 300px
            height 10px
            border 1px solid var(--bg-color-excel-table-scrollbar-outer)
            overflow hidden
            background-color var(--bg-color-excel-table-scrollbar-shadow)
            .scroller_shadow
                position absolute
                left 0
                top 0
                height 10px
                width 20px
                background-color var(--bg-color-excel-table-scrollbar-shadow)
                pointer-events none
            .scroller_inner
                position absolute
                top 1px
                bottom 0
                left 10px
                width 10px
                height 6px
                background-color var(--bg-color-excel-table-scrollbar-inner)
            .scroller_inner::before
                content ""
                position absolute
                left -10px
                top 0
                width 40px
                height 6px
                border-radius 4px
                background-color var(--bg-color-scrollbar)
            // .scroller_inner::after
            //     content ""
            //     position absolute
            //     right -15px
            //     top 0
            //     width 20px
            //     height 6px
            //     border-radius 4px
            //     border-top-left-radius 0
            //     border-bottom-left-radius 0
            //     background-color var(--bg-color-scrollbar)
        .scroller_outer_y
            position relative
            width 10px
            border 1px solid var(--bg-color-excel-table-scrollbar-outer)
            overflow hidden
            background-color var(--bg-color-excel-table-scrollbar-shadow)
            .scroller_shadow
                position absolute
                left 0
                top 0
                height 20px
                width 10px
                background-color var(--bg-color-excel-table-scrollbar-shadow)
                pointer-events none
            .scroller_inner
                position absolute
                top 10px
                bottom 0
                left 1px
                width 6px
                height 10px
                background-color var(--bg-color-excel-table-scrollbar-inner)
            .scroller_inner::before
                content ""
                position absolute
                left 0
                top -10px
                width 6px
                height 40px
                border-radius 4px
                background-color var(--bg-color-scrollbar)
            // .scroller_inner::after
            //     content ""
            //     position absolute
            //     left 0
            //     bottom -15px
            //     width 6px
            //     height 20px
            //     border-radius 4px;
            //     border-top-left-radius 0
            //     border-top-right-radius 0

            //     background-color var(--bg-color-scrollbar)
</style>

<template>
    <div class="scroller_container">
        <div id="scrollerOuter" class="scroller_outer_x" v-if="sliderType == 0" :style="`width:${outerSize}px`" @click="quickScroll($event)">
            <div id="scrollerShadow" class="scroller_shadow"></div>
            <div
                id="scrollerInner"
                class="scroller_inner"
                :class="{ active: sliderClickX }"
                :style="`width: ${sliderWidth}px;`"
                @mousedown="moveSlider($event)"
            ></div>
        </div>
        <div id="scrollerOuter2" class="scroller_outer_y" v-if="sliderType == 1" :style="`height:${outerSize}px`" @click="quickScroll($event)">
            <div id="scrollerShadow2" class="scroller_shadow"></div>
            <div
                id="scrollerInner2"
                class="scroller_inner"
                :class="{ active: sliderClickY }"
                :style="`height: ${sliderWidth}px;`"
                @mousedown="moveSlider($event)"
            ></div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({})
    export default class ExcelScroll extends Vue {
        @Prop()
        scrollSize: number;
        @Prop()
        scrollType: number;
        @Prop({
            type: Number,
            default: 20,
        })
        sliderWidth: number;

        sliderType: number = 1; // 0 横向，1 纵向
        outerSize: number = 200;

        sliderClickX: boolean = false;
        sliderClickY: boolean = false;

        getStyle(dom, attr) {
            return dom.currentStyle ? dom.currentStyle[attr] : getComputedStyle(dom)[attr];
        }
        moveSlider(e) {
            e.preventDefault();
            let slide = this.sliderType == 0 ? document.getElementById("scrollerInner") : document.getElementById("scrollerInner2");
            let shadow = this.sliderType == 0 ? document.getElementById("scrollerShadow") : document.getElementById("scrollerShadow2");
            let xstart = e.pageX;
            let ystart = e.pageY;
            let baseleft = this.getStyle(slide, "left").replace(/px/, "") - 0;
            let basetop = this.getStyle(slide, "top").replace(/px/, "") - 0;
            (this.sliderType == 0 && ((this.sliderClickX = true), true)) || (this.sliderClickY = true);
            document.onmousemove = (ev) => {
                let xmove = ev.pageX - xstart;
                let ymove = ev.pageY - ystart;
                let percent = 0;
                if (this.sliderType == 0) {
                    // 横向
                    let movewidth = baseleft + xmove;
                    movewidth =
                        movewidth < 10 ? 10 : movewidth > this.outerSize - 10 - this.sliderWidth ? this.outerSize - 10 - this.sliderWidth : movewidth;
                    slide.style.left = `${movewidth}px`;
                    shadow.style.width = `${movewidth}px`;
                    percent = (movewidth - 10) / (this.outerSize - 20 - this.sliderWidth);
                    this.$emit("xScroll", percent);
                } else if (this.sliderType == 1) {
                    let moveheight = basetop + ymove;
                    moveheight =
                        moveheight < 10
                            ? 10
                            : moveheight > this.outerSize - 10 - this.sliderWidth
                              ? this.outerSize - 10 - this.sliderWidth
                              : moveheight;
                    slide.style.top = `${moveheight}px`;
                    shadow.style.height = `${moveheight}px`;
                    percent = (moveheight - 10) / (this.outerSize - 20 - this.sliderWidth);
                    this.$emit("yScroll", percent);
                }
            };
            document.onmouseup = () => {
                (this.sliderType == 0 && ((this.sliderClickX = false), false)) || (this.sliderClickY = false);
                document.onmousemove = null;
                document.onmouseup = null;
            };
        }
        changeSliderSize(sliderType, percent) {
            if (sliderType == 0) {
                // 横向
                let slide = document.getElementById("scrollerInner");
                let shadow = document.getElementById("scrollerShadow");
                let movewidth = percent * (this.outerSize - 20 - this.sliderWidth) + 10;
                movewidth =
                    movewidth < 10 ? 10 : movewidth > this.outerSize - 10 - this.sliderWidth ? this.outerSize - 10 - this.sliderWidth : movewidth;
                slide.style.left = `${movewidth}px`;
                shadow.style.width = `${movewidth}px`;
            } else if (sliderType == 1) {
                let slide = document.getElementById("scrollerInner2");
                let shadow = document.getElementById("scrollerShadow2");
                let moveheight = percent * (this.outerSize - 20 - this.sliderWidth) + 10;
                moveheight =
                    moveheight < 10 ? 10 : moveheight > this.outerSize - 10 - this.sliderWidth ? this.outerSize - 10 - this.sliderWidth : moveheight;
                slide.style.top = `${moveheight}px`;
                shadow.style.height = `${moveheight}px`;
            }
        }
        quickScroll(e) {
            let target = e.target;
            if (target.id !== "scrollerOuter" && this.sliderType == 0) {
                return;
            }
            if (target.id !== "scrollerOuter2" && this.sliderType == 1) {
                return;
            }
            let clickposition = this.sliderType == 0 ? e.offsetX : e.offsetY;
            let percent = clickposition / this.scrollSize;
            this.changeSliderSize(this.sliderType, percent);
            (this.sliderType == 0 && (this.$emit("xScroll", percent), true)) || this.$emit("yScroll", percent);
        }

        mounted() {
            this.sliderType = this.scrollType;
            this.outerSize = this.scrollSize;
        }
    }
</script>
